import {
    MinimumUsage,
    useGetJobCostQuery,
} from 'components/customer/Job/store/jobApi';
import {useJobContext} from 'contexts';
import {useMemo} from 'react';
import {PartialJob} from 'shared/types/PartialJob';

export const useMinUsageInfo = () => {
    const {job} = useJobContext() as PartialJob;
    const {data: cost} = useGetJobCostQuery(
        {jobId: job.id},
        {
            skip: typeof job?.id === 'undefined',
        }
    );

    const moreInfoData = useMemo(() => {
        if (
            !cost ||
            (cost?.benchtopMaterialUsage?.length === 0 &&
                cost?.cabinetMaterialUsage?.length === 0 &&
                cost?.cabinetEdgeUsage?.length === 0)
        ) {
            return {
                benchtopMaterial: [],
                cabinetMaterial: [],
                cabinetEdge: [],
            };
        }

        const onlyWithCosts = (usage: MinimumUsage) =>
            (usage.areaCost || usage.lengthCost > 0) && usage.cost > 0;

        const benchtopMaterialUsage = cost.benchtopMaterialUsage ?? [];
        const cabinetMaterialUsage = cost.cabinetMaterialUsage ?? [];
        const cabinetEdgeUsage = cost.cabinetEdgeUsage ?? [];

        return {
            benchtopMaterial: benchtopMaterialUsage.filter(onlyWithCosts),
            cabinetMaterial: cabinetMaterialUsage.filter(onlyWithCosts),
            cabinetEdge: cabinetEdgeUsage.filter(onlyWithCosts),
        };
    }, [cost]);

    return {
        moreInfoData,
        totalMinUsage: cost?.totalMinUsage,
        manufacturerEditMinMatUsage: job?.manufacturerEditMinMatUsage,
    };
};
